import React from 'react';
import styled from 'styled-components';
import { colors, globals } from '../../styles';
import { TextInputProps } from './props';

export default class TextInput extends React.Component<
  TextInputProps,
  { placeholder: string }
> {
  public input: HTMLInputElement;

  state = {
    placeholder: '',
  };

  componentDidMount() {
    this.onBlur();
  }

  componentWillUnmount() {
    if (this.props.onComponentUnmount !== undefined) {
      this.props.onComponentUnmount('');
    }
  }

  onBlur = () => {
    const { field } = this.props;
    if (this.input.value === '' || (field && field.value === '')) {
      this.setState({ placeholder: this.props.placeholder });
    }
  };

  onFocus = () => {
    const { field } = this.props;
    if (
      (this.input && this.input.value === '') ||
      (field && field.value === '')
    ) {
      this.setState({ placeholder: '' });
    }
  };

  render() {
    const {
      className,
      disabled,
      errorText,
      id,
      label,
      name,
      onChange,
      type,
      isrequired,
      value,
      maxlength,
      autoComplete,
      autoFocus,
      input,
      meta,
      field,
      tabIndex,
    } = this.props;

    const disabledClass = disabled ? 'disabled' : '';
    const errorClass =
      errorText || (meta && meta.error && meta.touched) ? 'error' : '';

    const status =
      meta && meta.status ? meta.status : label && !errorText ? label : '';
    const error = meta && meta.touched && meta.error ? meta.error : errorText;

    return (
      <StyledTextInput className={className}>
        <input
          /* tslint:disable-next-line */
          ref={el => (this.input = el)}
          id={id}
          type={type}
          className={`input ${disabledClass} ${errorClass}`}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          name={name}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          onChange={onChange}
          placeholder={this.state.placeholder}
          required={isrequired}
          value={value}
          maxLength={maxlength}
          tabIndex={tabIndex}
          {...input}
          {...field}
        />
        {status && <div className="text-container status-text">{status}</div>}
        <div className="text-container error-text">{error}</div>
      </StyledTextInput>
    );
  }
}

const StyledTextInput = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;

  input {
    ${globals.input};
    width: 100%;
    box-shadow: 0 1px 0 ${colors.grey300};
    transition: all 100ms ease-out;
    text-align: center;
    margin-top: 1.5rem;
    padding-bottom: 0.25rem;

    :focus {
      box-shadow: 0 2px 0 ${colors.green500};
    }
    ::placeholder {
      color: ${colors.grey400};
    }
  }

  input.error {
    box-shadow: 0 1px 0 ${colors.alert};
  }

  .text-container {
    height: 1.5rem;
    padding: 0.25rem 0 0.5rem 0;
    font-size: 0.75rem;
    text-align: center;
  }

  .error-text {
    color: ${colors.alert};
  }

  .status-text {
    color: ${colors.grey600};
  }
`;
